import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 100%;
}

:host * {
  box-sizing: border-box;
}

.access-page {
  --navy-950: #07101f;
  --navy-900: #0a1628;
  --blue-700: #1d4ed8;
  --blue-600: #2563eb;
  --cyan-400: #22d3ee;
  --slate-950: #0f172a;
  --slate-700: #334155;
  --slate-500: #64748b;
  min-height: 100vh;
  min-height: 100dvh;
  display: grid;
  grid-template-columns: minmax(0, 1.14fr) minmax(480px, 0.86fr);
  overflow: hidden;
  color: var(--slate-950);
  background: #f4f7fb;
}

.access-visual {
  position: relative;
  min-width: 0;
  min-height: 100vh;
  min-height: 100dvh;
  padding: clamp(32px, 4.4vw, 68px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  isolation: isolate;
  color: #ffffff;
  background: radial-gradient(circle at 78% 42%, rgba(34, 211, 238, 0.12), transparent 28%), linear-gradient(145deg, #07101f 0%, #0a1830 52%, #081426 100%);
}

.access-visual::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  background: linear-gradient(90deg, rgba(7, 16, 31, 0.96) 0%, rgba(7, 16, 31, 0.68) 38%, rgba(7, 16, 31, 0.06) 72%);
}

.access-visual::after {
  content: "";
  position: absolute;
  inset: auto -18% -35% 15%;
  height: 70%;
  z-index: 0;
  border-radius: 50%;
  pointer-events: none;
  background: rgba(25, 109, 219, 0.2);
  filter: blur(110px);
}

.access-visual__grid {
  position: absolute;
  inset: 0;
  z-index: 0;
  opacity: 0.18;
  pointer-events: none;
  background-image: linear-gradient(rgba(125, 211, 252, 0.12) 1px, transparent 1px), linear-gradient(90deg, rgba(125, 211, 252, 0.12) 1px, transparent 1px);
  background-size: 52px 52px;
  mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.85), transparent 78%);
}

.access-visual__glow {
  position: absolute;
  top: -160px;
  left: 35%;
  width: 440px;
  height: 440px;
  z-index: 0;
  border-radius: 50%;
  opacity: 0.16;
  pointer-events: none;
  background: #38bdf8;
  filter: blur(110px);
}

.access-brand,
.access-visual__content,
.access-visual__footer {
  position: relative;
  z-index: 3;
}

.access-brand {
  display: flex;
  align-items: center;
  min-height: 38px;
  color: #f8fafc;
}

.access-brand__mark,
.mobile-brand__mark {
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  color: #a5f3fc;
  background: linear-gradient(145deg, rgba(34, 211, 238, 0.2), rgba(37, 99, 235, 0.25));
  border: 1px solid rgba(165, 243, 252, 0.22);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.14), 0 12px 36px rgba(2, 132, 199, 0.16);
}

.access-brand__mark {
  width: 38px;
  height: 38px;
  border-radius: 11px;
}

.access-brand__mark svg,
.mobile-brand__mark svg {
  width: 23px;
  height: 23px;
}

.access-brand__name {
  margin-left: 12px;
  font-size: 17px;
  font-weight: 750;
  letter-spacing: -0.02em;
}

.access-brand__divider {
  width: 1px;
  height: 18px;
  margin: 0 13px;
  background: rgba(148, 163, 184, 0.42);
}

.access-brand__descriptor {
  color: #94a3b8;
  font-size: 10px;
  font-weight: 650;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.access-visual__content {
  margin-top: clamp(68px, 10vh, 120px);
  max-width: 620px;
}

.access-kicker {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  margin: 0 0 22px;
  color: #a5f3fc;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.access-kicker__signal {
  position: relative;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--cyan-400);
  box-shadow: 0 0 16px rgba(34, 211, 238, 0.8);
}

.access-kicker__signal::after {
  content: "";
  position: absolute;
  inset: -4px;
  border: 1px solid rgba(34, 211, 238, 0.55);
  border-radius: inherit;
  animation: signal-ring 2.4s ease-out infinite;
}

.access-visual h1 {
  margin: 0;
  max-width: 610px;
  color: #f8fafc;
  font-size: clamp(40px, 4vw, 62px);
  font-weight: 740;
  line-height: 1.13;
  letter-spacing: -0.045em;
  text-wrap: balance;
}

.access-visual h1 span {
  color: transparent;
  background: linear-gradient(92deg, #67e8f9 0%, #93c5fd 55%, #c4b5fd 100%);
  background-clip: text;
  -webkit-background-clip: text;
}

.access-visual__description {
  margin: 24px 0 0;
  max-width: 520px;
  color: #aebbd0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.78;
  letter-spacing: -0.01em;
}

.access-visual__art {
  position: absolute;
  inset: 23% -9% -2% 6%;
  z-index: 0;
  pointer-events: none;
}

.access-visual__art::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, #07101f 0%, rgba(7, 16, 31, 0.5) 25%, transparent 55%);
}

.access-visual__art img {
  position: absolute;
  right: 0;
  bottom: 0;
  width: min(100%, 980px);
  height: 100%;
  object-fit: contain;
  object-position: right bottom;
  opacity: 0.9;
  filter: saturate(0.9) contrast(1.04);
  mask-image: linear-gradient(to bottom, transparent 0%, #000 13%, #000 88%, transparent 100%);
}

.access-visual__image-halo {
  position: absolute;
  right: 3%;
  bottom: 11%;
  width: 62%;
  aspect-ratio: 1;
  border-radius: 50%;
  opacity: 0.2;
  background: #22d3ee;
  filter: blur(90px);
}

.access-visual__scan {
  position: absolute;
  right: 9%;
  bottom: 11%;
  width: 62%;
  height: 1px;
  z-index: 2;
  opacity: 0.45;
  background: linear-gradient(90deg, transparent, #67e8f9 30%, #bfdbfe 70%, transparent);
  box-shadow: 0 0 18px rgba(34, 211, 238, 0.7);
  animation: neural-scan 6s ease-in-out infinite;
}

.visual-callout {
  position: absolute;
  z-index: 3;
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 7px 10px;
  color: #cbd5e1;
  font-size: 9px;
  font-weight: 650;
  letter-spacing: 0.11em;
  text-transform: uppercase;
  white-space: nowrap;
  border: 1px solid rgba(125, 211, 252, 0.2);
  border-radius: 999px;
  background: rgba(7, 16, 31, 0.58);
  backdrop-filter: blur(8px);
}

.visual-callout--retina {
  left: 48%;
  bottom: 33%;
}

.visual-callout--cortex {
  right: 13%;
  top: 24%;
}

.visual-callout__pulse {
  width: 5px;
  height: 5px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: #67e8f9;
  box-shadow: 0 0 10px rgba(103, 232, 249, 0.9);
}

.access-visual__footer {
  margin-top: auto;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
}

.capability-list {
  display: flex;
  align-items: stretch;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.capability-list li {
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 126px;
  padding: 10px 12px;
  border: 1px solid rgba(148, 163, 184, 0.17);
  border-radius: 11px;
  background: rgba(8, 20, 39, 0.58);
  backdrop-filter: blur(12px);
}

.capability-list__icon {
  display: grid;
  place-items: center;
  width: 29px;
  height: 29px;
  flex: 0 0 auto;
  color: #67e8f9;
  border: 1px solid rgba(103, 232, 249, 0.16);
  border-radius: 8px;
  background: rgba(34, 211, 238, 0.08);
}

.capability-list__icon svg {
  width: 16px;
  height: 16px;
}

.capability-list strong,
.capability-list small {
  display: block;
}

.capability-list strong {
  color: #e2e8f0;
  font-size: 10px;
  font-weight: 650;
  letter-spacing: -0.01em;
}

.capability-list small {
  margin-top: 2px;
  color: #64748b;
  font-size: 8px;
  font-weight: 550;
  letter-spacing: 0.05em;
}

.access-visual__status {
  display: flex;
  align-items: center;
  gap: 7px;
  margin: 0 0 5px;
  color: #64748b;
  font-size: 9px;
  font-weight: 650;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  white-space: nowrap;
}

.access-visual__status span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #34d399;
  box-shadow: 0 0 10px rgba(52, 211, 153, 0.55);
}

.access-auth {
  position: relative;
  min-width: 0;
  min-height: 100vh;
  min-height: 100dvh;
  padding: clamp(28px, 4.2vw, 64px);
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;
  overflow-y: auto;
  background: radial-gradient(circle at 100% 0%, rgba(59, 130, 246, 0.07), transparent 26%), #f5f7fb;
}

.access-auth__orb {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  filter: blur(2px);
}

.access-auth__orb--top {
  top: 5%;
  right: -90px;
  width: 210px;
  height: 210px;
  border: 1px solid rgba(37, 99, 235, 0.08);
  box-shadow: inset 0 0 70px rgba(59, 130, 246, 0.035);
}

.access-auth__orb--bottom {
  bottom: 3%;
  left: -90px;
  width: 190px;
  height: 190px;
  border: 1px solid rgba(34, 211, 238, 0.08);
}

.auth-container {
  position: relative;
  z-index: 2;
  width: min(100%, 458px);
  margin: auto 0;
}

.mobile-brand {
  display: none;
  align-items: center;
  gap: 10px;
  margin-bottom: 44px;
  color: var(--slate-950);
  font-size: 17px;
  font-weight: 750;
  letter-spacing: -0.02em;
}

.mobile-brand__mark {
  width: 36px;
  height: 36px;
  color: #0369a1;
  border-color: rgba(14, 116, 144, 0.12);
  background: linear-gradient(145deg, rgba(34, 211, 238, 0.15), rgba(37, 99, 235, 0.1));
  box-shadow: none;
}

.auth-heading {
  margin-bottom: 30px;
}

.auth-heading__eyebrow {
  margin: 0 0 11px;
  color: var(--blue-600);
  font-size: 10px;
  font-weight: 750;
  letter-spacing: 0.17em;
  text-transform: uppercase;
}

.auth-heading h2 {
  margin: 0;
  color: var(--slate-950);
  font-size: clamp(29px, 2.6vw, 36px);
  font-weight: 760;
  line-height: 1.25;
  letter-spacing: -0.04em;
}

.auth-heading > p:last-child {
  margin: 12px 0 0;
  color: var(--slate-500);
  font-size: 13px;
  line-height: 1.65;
  letter-spacing: -0.01em;
}

.auth-card {
  position: relative;
  padding: 8px 30px 24px;
  border: 1px solid rgba(203, 213, 225, 0.72);
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 24px 65px rgba(15, 23, 42, 0.08), 0 3px 12px rgba(15, 23, 42, 0.035);
  backdrop-filter: blur(18px);
}

.auth-tabs {
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 4px;
  margin: 0 -22px 27px;
  padding: 5px;
  border-radius: 16px;
  background: #f1f5f9;
}

.auth-tab {
  min-height: 41px;
  padding: 0 14px;
  color: #64748b;
  font: inherit;
  font-size: 12px;
  font-weight: 650;
  border: 0;
  border-radius: 12px;
  outline: none;
  background: transparent;
  transition: color 180ms ease, background 180ms ease, box-shadow 180ms ease;
}

.auth-tab:hover {
  color: #1e293b;
}

.auth-tab.is-active {
  color: #0f172a;
  background: #ffffff;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08), inset 0 0 0 1px rgba(203, 213, 225, 0.45);
}

.auth-tab:focus-visible {
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.18);
}

.auth-form {
  display: flex;
  flex-direction: column;
  gap: 19px;
  animation: form-enter 260ms ease-out;
}

.auth-form--signup {
  gap: 14px;
}

.form-field {
  min-width: 0;
}

.form-field label,
.form-label-row {
  display: flex;
  align-items: center;
}

.form-field label {
  margin-bottom: 8px;
  color: #334155;
  font-size: 12px;
  font-weight: 650;
  letter-spacing: -0.01em;
}

.form-label-row {
  justify-content: space-between;
  gap: 12px;
}

.form-label-row label {
  margin-bottom: 8px;
}

.form-label-row__hint {
  margin-bottom: 8px;
  color: #94a3b8;
  font-size: 9px;
  font-weight: 500;
}

.input-shell {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 50px;
  border: 1px solid #d8e0ea;
  border-radius: 12px;
  background: #fbfdff;
  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.025);
  transition: border-color 180ms ease, box-shadow 180ms ease, background 180ms ease;
}

.input-shell:hover {
  border-color: #b8c5d6;
}

.input-shell:focus-within {
  border-color: var(--blue-600);
  background: #ffffff;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);
}

.input-shell__icon {
  display: grid;
  place-items: center;
  width: 45px;
  flex: 0 0 45px;
  color: #94a3b8;
}

.input-shell__icon svg {
  width: 18px;
  height: 18px;
}

.input-shell:focus-within .input-shell__icon {
  color: var(--blue-600);
}

.input-shell input {
  width: 100%;
  min-width: 0;
  height: 48px;
  padding: 0 14px;
  color: #0f172a;
  font: inherit;
  font-size: 13px;
  font-weight: 500;
  border: 0;
  border-radius: inherit;
  outline: 0;
  background: transparent;
  box-shadow: none;
}

.input-shell__icon + input {
  padding-left: 0;
}

.input-shell input::placeholder {
  color: #a3afbf;
  font-weight: 400;
}

.input-shell input:-webkit-autofill,
.input-shell input:-webkit-autofill:hover,
.input-shell input:-webkit-autofill:focus {
  transition: background-color 9999s ease-out 0s;
  -webkit-text-fill-color: #0f172a;
}

.form-help {
  display: block;
  margin: 6px 2px 0;
  color: #94a3b8;
  font-size: 9px;
  line-height: 1.45;
}

.form-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.primary-action {
  position: relative;
  min-height: 51px;
  margin-top: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  overflow: hidden;
  color: #ffffff;
  font: inherit;
  font-size: 13px;
  font-weight: 700;
  border: 0;
  border-radius: 12px;
  outline: none;
  background: linear-gradient(110deg, #0f3b82 0%, #1d4ed8 58%, #0284c7 120%);
  box-shadow: 0 13px 28px rgba(29, 78, 216, 0.22);
  transition: transform 180ms ease, box-shadow 180ms ease, filter 180ms ease;
}

.primary-action::before {
  content: "";
  position: absolute;
  inset: 0;
  opacity: 0;
  background: linear-gradient(110deg, rgba(255, 255, 255, 0.09), transparent 52%);
  transition: opacity 180ms ease;
}

.primary-action:hover {
  transform: translateY(-1px);
  filter: saturate(1.08);
  box-shadow: 0 16px 32px rgba(29, 78, 216, 0.27);
}

.primary-action:hover::before {
  opacity: 1;
}

.primary-action:active {
  transform: translateY(0);
}

.primary-action:focus-visible {
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.2), 0 13px 28px rgba(29, 78, 216, 0.22);
}

.primary-action span,
.primary-action svg {
  position: relative;
  z-index: 1;
}

.primary-action svg {
  width: 17px;
  height: 17px;
  transition: transform 180ms ease;
}

.primary-action:hover svg {
  transform: translateX(3px);
}

.auth-card__security {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  margin-top: 21px;
  padding-top: 19px;
  color: #94a3b8;
  font-size: 9px;
  font-weight: 550;
  border-top: 1px solid #edf1f5;
}

.auth-card__security svg {
  width: 14px;
  height: 14px;
  color: #0d9488;
}

.access-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  margin-top: 25px;
  color: #94a3b8;
  font-size: 9px;
  font-weight: 550;
  letter-spacing: 0.025em;
}

.access-footer__dot {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: #cbd5e1;
}

@keyframes signal-ring {
  0% {
    opacity: 0.9;
    transform: scale(0.75);
  }
  75%, 100% {
    opacity: 0;
    transform: scale(1.7);
  }
}
@keyframes neural-scan {
  0%, 100% {
    bottom: 18%;
    opacity: 0;
  }
  15%, 85% {
    opacity: 0.48;
  }
  50% {
    bottom: 70%;
    opacity: 0.32;
  }
}
@keyframes form-enter {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 1220px) {
  .access-page {
    grid-template-columns: minmax(0, 1fr) minmax(450px, 0.82fr);
  }
  .access-visual {
    padding: 40px;
  }
  .access-visual h1 {
    font-size: clamp(38px, 4.1vw, 52px);
  }
  .capability-list li {
    min-width: 0;
  }
  .capability-list small,
  .access-visual__status {
    display: none;
  }
}
@media (max-width: 980px) {
  .access-page {
    display: block;
    overflow: visible;
  }
  .access-visual {
    display: none;
  }
  .access-auth {
    padding: 40px 24px;
    background: radial-gradient(circle at 100% 0%, rgba(34, 211, 238, 0.13), transparent 31%), radial-gradient(circle at 0% 100%, rgba(37, 99, 235, 0.09), transparent 28%), #f5f7fb;
  }
  .mobile-brand {
    display: flex;
  }
}
@media (max-width: 560px) {
  .access-auth {
    padding: 26px 18px;
  }
  .auth-container {
    width: 100%;
  }
  .mobile-brand {
    margin-bottom: 38px;
  }
  .auth-heading {
    margin-bottom: 24px;
  }
  .auth-heading h2 {
    font-size: 29px;
  }
  .auth-card {
    padding: 7px 21px 21px;
    border-radius: 19px;
  }
  .auth-tabs {
    margin: 0 -14px 24px;
  }
  .form-row {
    grid-template-columns: 1fr;
    gap: 14px;
  }
  .access-footer {
    flex-wrap: wrap;
  }
}
@media (min-width: 981px) and (max-height: 760px) {
  .access-visual,
  .access-auth {
    padding-top: 28px;
    padding-bottom: 28px;
  }
  .access-visual__content {
    margin-top: 44px;
  }
  .auth-heading {
    margin-bottom: 20px;
  }
  .auth-heading__eyebrow {
    margin-bottom: 7px;
  }
  .auth-heading > p:last-child {
    margin-top: 7px;
  }
  .auth-card {
    padding-bottom: 18px;
  }
  .auth-tabs {
    margin-bottom: 20px;
  }
  .auth-form {
    gap: 14px;
  }
  .input-shell {
    min-height: 45px;
  }
  .input-shell input {
    height: 43px;
  }
  .primary-action {
    min-height: 46px;
  }
  .auth-card__security {
    margin-top: 15px;
    padding-top: 14px;
  }
  .access-footer {
    margin-top: 15px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .access-kicker__signal::after,
  .access-visual__scan,
  .auth-form {
    animation: none;
  }
  .auth-tab,
  .input-shell,
  .primary-action,
  .primary-action::before,
  .primary-action svg {
    transition: none;
  }
}`],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public view: string = 'login';

    public data: any = {
        identifier: '',
        password: ''
    };

    public signupData: any = {
        id: '',
        name: '',
        email: '',
        mobile: '',
        password: '',
        password_confirm: ''
    };

    public async ngOnInit() {
        await this.service.init();
        if (this.service.auth.check()) {
            location.href = this.service.auth.session?.role === 'ADMIN' ? '/members' : '/dashboard';
            return;
        }

        if (new URLSearchParams(location.search).get('expired') === '1') {
            await this.alert('로그인 세션이 만료되었습니다. 다시 로그인해주세요.');
        }
        await this.service.render();
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: '',
            message: message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status: status
        });
    }

    public async setView(view: string) {
        this.view = view;
        await this.service.render();
    }

    public async login() {
        const user = {
            identifier: (this.data.identifier || '').trim(),
            password: this.data.password || ''
        };

        if (!user.identifier || !user.password) {
            await this.alert('아이디와 비밀번호를 입력해주세요.');
            return;
        }

        const { code, data } = await wiz.call('login', user);
        if (code === 200) {
            location.href = data?.redirect || '/dashboard';
            return;
        }
        await this.alert(data?.message || data || '로그인에 실패했습니다.');
    }

    public async signup() {
        const user = JSON.parse(JSON.stringify(this.signupData));
        user.id = (user.id || '').trim();
        user.name = (user.name || '').trim();
        user.email = (user.email || '').trim().toLowerCase();
        user.mobile = (user.mobile || '').trim();

        if (!/^[A-Za-z0-9_.-]{4,32}$/.test(user.id)) {
            await this.alert('아이디는 영문, 숫자, 점, 밑줄, 하이픈으로 4~32자 입력해주세요.');
            return;
        }
        if (!user.name) {
            await this.alert('이름을 입력해주세요.');
            return;
        }
        if (!user.email || user.email.indexOf('@') < 1) {
            await this.alert('올바른 이메일을 입력해주세요.');
            return;
        }
        if (!user.password || user.password.length < 8) {
            await this.alert('비밀번호는 8자 이상 입력해주세요.');
            return;
        }
        if (user.password !== user.password_confirm) {
            await this.alert('비밀번호 확인이 일치하지 않습니다.');
            return;
        }

        const { code, data } = await wiz.call('signup', user);
        if (code === 200) {
            location.href = data?.redirect || '/dashboard';
            return;
        }
        await this.alert(data?.message || data || '회원가입에 실패했습니다.');
    }
}

export default PageAccessComponent;